import {axiosConfigNew as axios} from "../../../utils/axios";

export const apiGetJournalTable = (body: any) =>
  axios.get('/edu/grade-journal', {
    params: body
  });

export const apiJournalMark = (body: any) => axios({
  method: body.api_method,
  url: `edu/mark${body.id ? `/${body.id}` : ''}`,
  data: body
})

export const apiPerformance = (body: any) => axios.get(`/edu/performance`, {
  params:body
});

export const apiGetSdotByMark = (body: any) => axios.get(`/sdot/result`, {
  params: {
    lesson_id: body.lesson_id,
    student_id: body.student_id,
  }
});


export const apiGetSdotByMarkCurrent = (body: any) => axios.get(`/sdot/${body.type}`, {
  params: {
    lesson_id: body.lesson_id,
    student_id: body.student_id,
    // lesson_id: 114898,
    // student_id: 1336,
  }
});

export const apiGetTestResultByStudent = (body: any) => axios.get(`/sdot/test-result`, {
  params: {
    test_id: body.test_id,
    person_id: body.student_id,
  }
});

export const apiGetJournalTablePracticeAccounting = (body: any) => axios.get(`/edu/practice-accounting`, {
  params: body
});

export const apiGetJournalTableView = (body: any) => axios.get(`/edu/grade-journal-view`, {
  params: body
});

export const apiGetJournalTableExport = (body: any) => axios.get(`/edu/grade-journal-export`, {
  params: body
});

export const apiGetJournalTableLog = (body: any) => axios.get(`/edu/grade-log`, {
  params: body
});


